export default __webpack_public_path__ + "static/media/no_data.29129b63.svg";